.badge {
  display: inline-block;
  padding: var(--space-xs) var(--space-s);
  border-radius: var(--border-radius-s);
  margin: var(--space-xs);
}

.grey {
  background: var(--color-svp-grey);
}

.green {
  background: var(--color-light-green);
}

.small {
  font-size: var(--font-size-xs);
  padding: var(--space-xs);
}
